export default [
  { label: 'Binaria', value: 'binary' },
  { label: 'Escala de Likert', value: 'likert' },
  { label: 'Selección múltiple', value: 'choices' }
];
